import { MakeCall } from './createMakeCall';
import { Poi } from './types/Poi';

const getPoiCommercial = (makeCall: MakeCall) => (poiId: number) =>
  makeCall<Poi>('GET', `/api/v2/poi/${poiId}/commercial`);
export { getPoiCommercial };
